<div class="wrap">
  <ng-container *ngIf="!confirmSubmit">

    <ng-container *ngIf="showComment; else hideComment">
      <h2>Souhaitez-vous ajouter un commentaire ?</h2>

      <form [formGroup]="commentForm" id="commentForm" class="input_google_search" *ngIf="commentForm">

        <mat-form-field appearance="outline" class="commentField">
          <mat-label>Commentaire à destination du club</mat-label>
          <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"
            formControlName="comment"></textarea>
          <mat-error>Le commentaire ne doit pas dépasser 500 caractères.</mat-error>
        </mat-form-field>
      </form>
    </ng-container>

    <ng-template #hideComment>
      <h2 *ngIf="!payementActive">Modalités de paiement</h2>
      <h2 *ngIf="payementActive">Procéder au paiement</h2>

      <ng-container *ngIf="!payementActive">
        <mat-radio-group aria-labelledby="radio-group-label" [color]="color" class="radio-group"
          (change)="getTypeOfPayment($event)">
          <mat-radio-button
            *ngIf="amountAdvance !== amount && amountAdvance !== 0 && !hasToPayAdvanceAndOnline && !hasToPayOnlyLicences"
            class="radio-button" value="advance" [checked]="typePayment==='advance'">
            Payer uniquement les acomptes <strong>{{amountAdvance}}€</strong>
          </mat-radio-button>

          <mat-radio-button
            *ngIf="!canPayToClub && amountAdvance !== 0 && hasToPayAdvanceAndOnline && !hasToPayOnlyLicences"
            class="radio-button" value="advanceAndOnline" [checked]="typePayment==='advanceAndOnline'">
            Payer les acomptes, les licences et les offres en ligne <strong>{{amountAdvanceAndOnline}}€</strong>
          </mat-radio-button>

          <mat-radio-button
            *ngIf="!canPayToClub && amountAdvance === 0 && !hasToPayAdvanceAndOnline && hasToPayOnlyLicences || hasLicencesToPay && amountLicences > 0"
            class="radio-button" value="onlyLicences" [checked]="typePayment==='onlyLicences'">
            Payer les licences <strong>{{amountLicences}}€</strong>
          </mat-radio-button>

          <mat-radio-button *ngIf="!hasToPayOnlyLicences" class="radio-button" value="total"
            [checked]="typePayment==='total'">
            Payer la totalité <strong>{{amount}}€</strong>
          </mat-radio-button>

          <mat-radio-button *ngIf="canPayToClub && amountAdvance === 0" class="radio-button" value="payToClub"
            [checked]="typePayment==='payToClub'">
            Payer au club
          </mat-radio-button>


        </mat-radio-group>
      </ng-container>

      <ng-container *ngIf="payementActive">
        <div class="loading" *ngIf="loading">
          <mat-spinner [diameter]="50"></mat-spinner>
        </div>

        <div class="paymentContainer">

          <div class="infosContainer">
            <h3>100% Sécurisé <fa-icon [icon]="getFaIcon('faLock')"></fa-icon></h3>
            <p>
              Vos données bancaires sont sécurisées selon les dernières normes via la plateforme sécurisée Systempay.
              Solution de paiement certifiée PCI-DSS hautement sécurisée agréé Banque Populaire.
            </p>
            <div class="logosSystem">
              <img src="../../../../assets/img/pci_dss.png">
              <img src="../../../../assets/img/systempay.jpg">
            </div>


          </div>

          <div>
            <div *ngIf="!loading" class="titleForm">
              <h3>Votre transaction</h3>
              <!-- <img src="../../../../assets/img/logo ligue HDF.png"> -->
              <img *ngIf="logoClub" class="logoClub" [src]="logoClub" alt="logo_club">

            </div>
            <div id="myPaymentForm"></div>

            <div *ngIf="!loading" class="logosContainer">
              <img src="../../../../assets/img/logos_paiements.png">
            </div>
          </div>

        </div>

      </ng-container>

      <p *ngIf="!payementActive && typePayment !== 'payToClub' && !showComment" class="paymentMessage">
        <i>*Une fois validé, Vous allez être redirigé vers une page de paiement sécurisée.</i>
      </p>
    </ng-template>



    <div class="btn_action">
      <button class="back" (click)="dialogRef.close(bookingKey)" [hidden]="payementActive && loading">Annuler</button>
      <button class="confirm" *ngIf="!payementActive && !showComment"
        (click)="showComment = !showComment">Retour</button>
      <button class="confirm" *ngIf="!payementActive && typePayment !== 'payToClub' && !showComment"
        (click)="gotToPayment()" [disabled]="!typePayment" [style.opacity]="!typePayment? .5 : 1">
        <fa-icon [icon]="getFaIcon('faLock')"></fa-icon>
        Procéder au paiement
      </button>
      <button class="confirm" *ngIf="typePayment === 'payToClub' && !showComment" (click)="confirmBook()">Réserver
      </button>

      <button class="confirm" *ngIf="showComment && typePayment !== 'payToClub'"
        (click)="showComment = !showComment; checkAmount()" form="commentForm"
        (click)="commentForm.invalid ? null : showComment = !showComment"
        [style.opacity]="commentForm.invalid? .5 : 1">Suivant</button>
    </div>

  </ng-container>

  <ng-container *ngIf="confirmSubmit">
    <app-validation-animation [text]="'Réservation confirmée'"></app-validation-animation>
    <p>Retrouvez à tout instant vos réservations dans l'onglet <strong [routerLink]="['/home/purchases-history']"
        routerLinkActive="router-link-active" appChangeColorTheme attribute="color">Historique de mes
        réservations</strong></p>

    <button class="export_bill_pdf" appChangeColorTheme attribute="bgc" (click)="exportPdfBill()">
      <fa-icon [icon]="getFaIcon('faFilePdf')"></fa-icon>
      Ma facture
    </button>


    <div class="btn_action">
      <div class="confirm" [routerLink]="['/home/purchases-history']" (click)="dialogRef.close()" appChangeColorTheme
        attribute="bgc">Mes réservations</div>
      <div class="confirm" (click)="dialogRef.close()" appChangeColorTheme attribute="bgc">Fermer</div>
    </div>

  </ng-container>
</div>